import { Link } from 'react-router-dom';
import { usePlatformSettings } from '../hooks/usePlatformSettings';
import FeatureShowcase from '../components/FeatureShowcase';
import ExplainerVideo from '../components/ExplainerVideo';
import './Landing.css';

export default function Landing() {
  const { settings } = usePlatformSettings();

  return (
    <div className="landing" data-testid="landing-page">
      <nav className="landing-nav">
        <div className="nav-content">
          <div className="logo">
            {settings.platform_logo_url ? (
              <img 
                src={`${settings.platform_logo_url}?v=${Date.now()}`} 
                alt={settings.platform_name}
                className="logo-image"
              />
            ) : (
              <span className="logo-icon">{settings.platform_logo_text}</span>
            )}
            <span className="logo-text">{settings.platform_name}</span>
          </div>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <h1 data-testid="hero-title">Manage Your Group Finances with Confidence</h1>
          <p className="hero-subtitle">
            Empower your benevolence groups and savings saccos with comprehensive
            financial management, transparent tracking, and secure disbursements.
          </p>

          <div className="login-options">
            <Link to="/login?type=leadership" className="btn btn-primary" data-testid="leadership-login-btn">
              Leadership Login
            </Link>
            <Link to="/login?type=member" className="btn btn-secondary" data-testid="member-login-btn">
              Member Login
            </Link>
          </div>

          <div className="signup-link">
            Don't have an account? <Link to="/register">Sign up here</Link>
            <br />
            <span className="member-signup-link">
              Group member? <Link to="/member-signup">Complete your registration</Link>
            </span>
          </div>
        </div>

        <div className="hero-visual">
          <div className="floating-card card-1">
            <div className="card-icon">👥</div>
            <div className="card-title">Member Management</div>
          </div>
          <div className="floating-card card-2">
            <div className="card-icon">💵</div>
            <div className="card-title">Payment Tracking</div>
          </div>
          <div className="floating-card card-3">
            <div className="card-icon">📊</div>
            <div className="card-title">Analytics & Reports</div>
          </div>
        </div>
      </section>

      {/* Explainer Video Section */}
      <ExplainerVideo />

      {/* Feature Showcase Slideshow */}
      <FeatureShowcase />

      <section className="features">
        <h2>Everything You Need to Manage Your Group</h2>
        <div className="features-grid">
          <div className="feature-card card">
            <div className="feature-icon">📝</div>
            <h3>Member Enrollment</h3>
            <p>Easily onboard and manage member data with downloadable spreadsheets</p>
          </div>
          <div className="feature-card card">
            <div className="feature-icon">💳</div>
            <h3>Payment Processing</h3>
            <p>Secure payments via Stripe with card and ACH bank transfer options</p>
          </div>
          <div className="feature-card card">
            <div className="feature-icon">📚</div>
            <h3>Books of Accounts</h3>
            <p>Complete tracking of payments and disbursements</p>
          </div>
          <div className="feature-card card">
            <div className="feature-icon">🔔</div>
            <h3>Payment Reminders</h3>
            <p>Automated and manual payment notifications to members</p>
          </div>
          <div className="feature-card card">
            <div className="feature-icon">📈</div>
            <h3>Analytics Dashboard</h3>
            <p>Comprehensive insights with downloadable summaries</p>
          </div>
          <div className="feature-card card">
            <div className="feature-icon">✅</div>
            <h3>Multi-Signature Approvals</h3>
            <p>Secure disbursements with 3-signatory approval system</p>
          </div>
        </div>
      </section>

      {/* Hidden admin access at bottom corner */}
      <div className="hidden-admin-access">
        <Link to="/login?type=admin" className="subtle-admin-link" title="Admin">⚙</Link>
      </div>
    </div>
  );
}